var vars = require('./core');

module.exports = vars.createClass('Bubble', ['getPointsAtEvent']);



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-chartjs/lib/bubble.js
 ** module id = 968
 ** module chunks = 2
 **/